/* ============================================================
   INDEX PAGE — Phase 5: Lazy section reveal (idea 43)
   Adds scroll-triggered fade-in to below-fold section wrappers
   that aren't already animated by Fox theme's motion-element.
   Safe: class is only added via JS — no-JS visitors see full content.
   ============================================================ */
(function () {
  'use strict';

  if (typeof IntersectionObserver === 'undefined') return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const TARGETS = [
    'shopify-section-gift_finder_quiz_main',
    'shopify-section-video_gallery_preview_hPvR3x',
    'shopify-section-newsletter_rFpTxK',
  ];

  const observer = new IntersectionObserver(
    function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('idx-section-active');
        observer.unobserve(entry.target);
      });
    },
    { threshold: 0.08 }
  );

  function init() {
    TARGETS.forEach(function (id) {
      const el = document.getElementById(id);
      if (!el) return;
      const r = el.getBoundingClientRect();
      if (r.top < window.innerHeight && r.bottom > 0) return;
      el.classList.add('idx-section-reveal');
      observer.observe(el);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
